<template>
  <normal-dialog
    :visible="visible"
    :before-close="resetDialog"
    @update:visible="updateVisibleHandle"
    append-to-body
    top="5%"
    width="1040px"
    class="Detail-Dialog"
  >
    <form-line>
      <search-item label="月份">
        <date-picker
          v-model="yearChoice"
          format="yyyy-MM"
          type="month"
          value-format="yyyy-MM"
          :pickerOptions="endPickerOper"
          :noLabel="true"
        />
      </search-item>
      <el-button
        type="primary"
        @click="searchList"
      >查询</el-button>
    </form-line>
    <div class="listData-table">
      <md-table
        :data="listData"
        v-loading="loading"
      >
        <md-table-column
          label="月份"
          min-width="100"
          prop="createDate"
          align="center"
          fixed
        >
          <template slot-scope="scope">
            <div
              class="month_bt"
              @click="showDetailMonth(scope.row)"
            >{{scope.row.createDate}}</div>
          </template>
        </md-table-column>
        <md-table-column
          label="运营商"
          min-width="100"
          prop="operateName"
        />
        <md-table-column
          label="消费总额"
          min-width="100"
          prop="orderMoney"
          align="right"
          :formatter="(r,c,val) =>  this.$formatPrice(val)"
        />
        <md-table-column
          label="需收费消费总额"
          min-width="110"
          prop="needOrderMoney"
          align="right"
          :formatter="(r,c,val) =>  this.$formatPrice(val)"
        />
        <md-table-column
          label="不收费消费总额"
          min-width="110"
          prop="unneedOrderMoney"
          align="right"
          :formatter="(r,c,val) =>  this.$formatPrice(val)"
        />
        <md-table-column
          label="按订单服务费用"
          min-width="110"
          prop="platformFeeMoney"
          align="right"
          :formatter="(r,c,val) =>  this.$formatPrice(val)"
        />
        <md-table-column
          label="按订单免费费用"
          min-width="110"
          prop="unneedFeeMoney"
          align="right"
          :formatter="(r,c,val) =>  this.$formatPrice(val)"
        />
        <md-table-column
          label="按梯度服务费用"
          min-width="110"
          prop="gradMoney"
          align="right"
          :formatter="(r,c,val) =>  this.$formatPrice(val)"
        />
        <md-table-column
          label="实际应收服务费"
          min-width="110"
          prop="actualMoney"
          align="right"
          :formatter="(r,c,val) =>  this.$formatPrice(val)"
        />
      </md-table>
    </div>

  </normal-dialog>
</template>

<script>
import dialogMixin from '../../mixins/dialog';

export default {
  mixins: [dialogMixin],
  props: {
    listData: { type: Array },
    fetchPlatformMonthList: { type: Function },
  },
  data() {
    return {
      yearChoice: '',
      endPickerOper: {
        disabledDate: time => {
          if (time.getTime() > new Date().getTime()) {
            return true;
          }
        },
      },
    };
  },
  methods: {
    searchList() {
      let entity = {};
      let yearChoiceArr = this.yearChoice ? this.yearChoice.split('-') : [];
      const [year, month] = yearChoiceArr;
      if (year) {
        entity.year = year;
      }
      if (month) {
        entity.month = month;
      }
      this.fetchPlatformMonthList(entity);
    },
  },
};
</script>

<style lang="scss">
.Detail-Dialog {
  .listData-table {
    height: 400px;
  }
}
</style>
